<template>
  <div class="row">
    <div class="col-lg-12">
      <ul class="mb-0">
        <li
          class="li_style_none"
          v-for="(option, index) in ['Sim', 'Não']"
          :key="index"
        >
          <span
            class="d-inline"
            :class="{
              'font-weight-bold': answer.choices.marked[0] == options[index],
            }"
            >{{
              answer.choices.marked[0] == options[index]
                ? `* ${option}`
                : option
            }}</span
          >
          <RightOrWrongIcons
            ParentDivClasses="d-inline"
            :hide="question.choices.correctAnswer == 'any'"
            :useSvg="useSvg"
            :rightIf="question.choices.correctAnswer == options[index]"
            :wrongIf="question.choices.correctAnswer != options[index]"
          />
        </li>
      </ul>
    </div>
    <div class="col-lg-12">
      <span class="f14">(<b>*</b>) Opção que o candidato(a) marcou</span>
    </div>
  </div>
</template>

<script>
import RightOrWrongIcons from "components/RightOrWrongIcons.vue";

export default {
  props: {
    answer: {
      type: Object,
      default: () => {},
      required: true,
    },
    useSvg: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  components: { RightOrWrongIcons },
  data: () => ({
    options: ["yes", "no"],
  }),
  computed: {
    question() {
      return this.answer.question;
    },
  },
};
</script>